var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 101,
    viewBox: "0 0 47 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29865 80.0142L7.64028 79.8825L7.47966 80.6856H8.29865V80.0142ZM18.6921 28.0469L19.2032 27.6115L18.3053 26.5574L18.0337 27.9152L18.6921 28.0469ZM22.3983 32.3976V33.069H23.8522L22.9094 31.9622L22.3983 32.3976ZM5.801 32.3976L5.14286 32.2648L4.98053 33.069H5.801V32.3976ZM7.57352 23.6156V22.9442H7.02409L6.91538 23.4827L7.57352 23.6156ZM30.0524 23.6156L30.7108 23.7472L30.8714 22.9442H30.0524V23.6156ZM18.7727 80.0142V80.6856H19.3231L19.431 80.1458L18.7727 80.0142ZM8.95702 80.1458L19.3505 28.1786L18.0337 27.9152L7.64028 79.8825L8.95702 80.1458ZM18.181 28.4823L21.8872 32.833L22.9094 31.9622L19.2032 27.6115L18.181 28.4823ZM22.3983 31.7262H5.801V33.069H22.3983V31.7262ZM6.45914 32.5305L8.23167 23.7484L6.91538 23.4827L5.14286 32.2648L6.45914 32.5305ZM7.57352 24.287H30.0524V22.9442H7.57352V24.287ZM29.394 23.4839L18.1143 79.8825L19.431 80.1458L30.7108 23.7472L29.394 23.4839ZM18.7727 79.3428H8.29865V80.6856H18.7727V79.3428Z",
    fill: "url(#paint0_linear_1327_2796)",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7127 79L30.1062 27.0327L33.8124 31.3835H17.2151L18.9876 22.6014H41.4665L30.1867 79H19.7127Z",
    fill: "url(#paint1_linear_1327_2796)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1327_2796",
    x1: 15.5,
    y1: 2.01416,
    x2: 15.5,
    y2: 100.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DDD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196FF0",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1327_2796",
    x1: 29.2065,
    y1: 0,
    x2: 29.2065,
    y2: 100.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7CEC",
    stopOpacity: 0.68
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo1);
export default __webpack_public_path__ + "static/media/No1.6468cb8bbd6557b9e89d135ad06a8cc8.svg";
export { ForwardRef as ReactComponent };